// extracted by mini-css-extract-plugin
export default {"wrapper":"nodata_wrapper__K8se9","img":"nodata_img__JRKto","message":"nodata_message__hYxa2"};